export default "__VITE_ASSET__BI2ZIY0r__"